/* eslint-disable no-unneeded-ternary */
import React from 'react'

// Components
import { Paragraph } from 'components/StyledComponents'

// Third Party
import styled from 'styled-components'

const SwitchFilterWrapper = styled.div`
  @media(max-width: 991px) {
    justify-content: space-evenly;
  }
`

const SwitchButton = styled.div`
  cursor: pointer;
  transition: 0.25s;

  :hover {
    transform: scale(1.05);
  }
`

const SwitchFilter = ({
  className,
  activeFilterType1,
  activeFilterType2,
  onChange1,
  onChange2,
  type1,
  type2
}) => (
  <SwitchFilterWrapper className={`d-flex justify-content-lg-between ${className ? `${className}` : ``}`}>
    <div role="button" tabIndex="0" onKeyDown={() => onChange1(activeFilterType1 === false ? true : false)} onClick={() => onChange1(activeFilterType1 === false ? true : false)}>
      <SwitchButton className={`px-4 py-2 ${!activeFilterType1 ? `color-background-secondary` : `color-background-main color-text-light`}`}>
        <Paragraph>{type1}</Paragraph>
      </SwitchButton>
    </div>
    <div role="button" tabIndex="0" onKeyDown={() => onChange2(activeFilterType2 === false ? true : false)} onClick={() => onChange2(activeFilterType2 === false ? true : false)}>
      <SwitchButton className={`px-4 py-2 ${!activeFilterType2 ? `color-background-secondary` : `color-background-main color-text-light`}`}>
        <Paragraph>{type2}</Paragraph>
      </SwitchButton>
    </div>
  </SwitchFilterWrapper>
)

export default SwitchFilter